var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.editorState === 'loading-presentation' ||
      _vm.editorState === 'select-subtitles' ||
      _vm.editorState === 'loading-subtitles'
    )?[_c('LoadingView',{attrs:{"editor-state":_vm.editorState,"loading-errors":_vm.loadingErrors},on:{"subtitles-selected":_vm.loadPresentationSubtitles}})]:_vm._e(),(_vm.editorState === 'edit-subtitles')?[_c('Editor')]:_vm._e(),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.showModal)?_c('Modal'):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }